import i18n from "i18next";

import { MarketType, LanguageType } from "../../types";
import getLanguageFromUrl from "./getLanguageFromUrl";

const languageMapping: Record<MarketType, LanguageType> = {
  KR: "ko",
  HK: "zh-HK",
  TW: "zh-TW",
  JP: "ja",
};

export default function changeLanguageByMarket(
  market: MarketType,
  setLanguage: (data: LanguageType) => void,
) {
  const languageFromUrl = getLanguageFromUrl();
  const language = languageFromUrl ?? languageMapping[market];

  i18n.changeLanguage(language, () => {
    setLanguage(language);
  });
}
